import React from 'react'
import _ from 'lodash'
import { SPORTS_TYPE_NUM } from '@interface/common'
import { TimelineEventType } from '@interface/chat'
import { TimelineTextWrap } from '@components/SportTalkItem/index.style'
import { SPORT_ID_ICON_MAP } from '@shared/SportIdGroup'
import cornerKickImg from '@assets/images/icon/soccer_timeline_icon/corner-kick.png'
import cardImg from '@assets/images/icon/soccer_timeline_icon/card.png'
import yellowCardImg from '@assets/images/icon/soccer_timeline_icon/yellow-card.png'
import redCardImg from '@assets/images/icon/soccer_timeline_icon/red-card.png'
import { Schema$SportTalkTimelineAll } from '@interface/cheer-for-team'
import { TIMELINE_TEAM_TYPE } from '@v2/constants/common'
import ConvertUtils from '@v2/utils/convert-utils'

interface AdvTimelineContentProps {
  sportId: number
  homeTeamName: string
  awayTeamName: string
  timeline: Schema$SportTalkTimelineAll
}

function AdvTimelineContent(props: AdvTimelineContentProps) {
  const {
    sportId,
    homeTeamName,
    awayTeamName,
    timeline,
  } = props

  const {
    contentHomeScore = 0,
    contentAwayScore = 0,
    matchClock,
    type: timelineEventType,
    team: timelineTeam,
    player,
    goalScorer,
    assist,
    isContentEmpty = false,
  } = timeline


  const clock = _.head(_.split(matchClock, ':')) || ''
  const eventGoalPlayerName = goalScorer?.name || ''
  const eventPlayerName = player?.name || ''
  const eventAssistPlayerName = _.head(assist)?.name || ''

  let currentEventTeamName: string
  if (timelineTeam === TIMELINE_TEAM_TYPE.HOME) {
    currentEventTeamName = homeTeamName
  } else if (timelineTeam === TIMELINE_TEAM_TYPE.AWAY) {
    currentEventTeamName = awayTeamName
  }

  /* --------- 축구 --------- */
  const renderSoccer = () => {
    const SOCCER_TIMELINE_ICON_MAP_KEY = {
      CORNER_KICK: 'corner_kick',
      YELLOW_RED_CARD: 'yellow_red_card',
      YELLOW_CARD: 'yellow_card',
      RED_CARD: 'red_card',
    }

    const SOCCER_TIMELINE_ICON_MAP = {
      [SOCCER_TIMELINE_ICON_MAP_KEY.CORNER_KICK]: <img src={cornerKickImg} className="sport-ico" alt="score corner kick"/>,
      [SOCCER_TIMELINE_ICON_MAP_KEY.YELLOW_RED_CARD]: <img src={cardImg} className="sport-ico" alt="score card"/>,
      [SOCCER_TIMELINE_ICON_MAP_KEY.YELLOW_CARD]: <img src={yellowCardImg} className="sport-ico" alt="score yellow card"/>,
      [SOCCER_TIMELINE_ICON_MAP_KEY.RED_CARD]: <img src={redCardImg} className="sport-ico" alt="score red card"/>,
    }

    switch (timelineEventType) {
      case TimelineEventType.SCORE_CHANGE:
        return (
          <>
            <div className="timeline--image--wrap">
              <div className="timeline--image">
                {SPORT_ID_ICON_MAP[sportId]}
              </div>
              <p className="timeline--text">{clock}&#39; - {currentEventTeamName}</p>
            </div>
            {!_.isEmpty(eventAssistPlayerName) && (<p className="timeline--text">도움 : {eventAssistPlayerName}</p>)}
            {!_.isEmpty(eventGoalPlayerName) && (<p className="timeline--text">득점 : {eventGoalPlayerName}</p>)}
          </>
        )

      case TimelineEventType.CORNER_KICK:
        return (
          <>
            <div className="timeline--image--wrap">
              <div className="timeline--image">
                {SOCCER_TIMELINE_ICON_MAP[timelineEventType]}
              </div>
              <p className="timeline--text">{clock}&#39; - {currentEventTeamName}</p>
            </div>
            {!_.isEmpty(eventPlayerName) && (<p className="timeline--text">선수 : {eventPlayerName}</p>)}
          </>
        )

      case TimelineEventType.YELLOW_CARD:
      case TimelineEventType.RED_CARD:
      case TimelineEventType.YELLOW_RED_CARD:
        return (
          <>
            <div className="timeline--image--wrap">
              <div className="timeline--image">
                {SOCCER_TIMELINE_ICON_MAP[timelineEventType]}
              </div>
              <p className="timeline--text">{clock}&#39; - {currentEventTeamName}</p>
            </div>
            {!_.isEmpty(eventPlayerName) && (<p className="timeline--text">선수 : {eventPlayerName}</p>)}
            <p className="timeline--text">카드 종류 : {ConvertUtils.soccerDisciplinaryText(timelineEventType)}</p>
          </>
        )

      default:
        return null
    }
  }

  /* --------- 야구 --------- */
  const renderBaseball = () => {
    if (timelineEventType === TimelineEventType.SCORE_CHANGE) {
      return (
        <>
          <div className="timeline--image--wrap">
            <div className="timeline--image">
              {SPORT_ID_ICON_MAP[sportId]}
            </div>
            <p className="timeline--text">{currentEventTeamName}</p>
          </div>
          {!_.isEmpty(eventGoalPlayerName)&&(<p className="timeline--text">홈인 : {eventGoalPlayerName}</p>)}
          {!_.isEmpty(eventAssistPlayerName)&&(<p className="timeline--text">타자 : {eventAssistPlayerName}</p>)}
        </>
      )
    }
    return null
  }

  /* --------- 아이스하키 --------- */
  const renderIceHockey = () => {
    if (timelineEventType === TimelineEventType.SCORE_CHANGE) {
      return (
        <>
          <div className="timeline--image--wrap">
            <div className="timeline--image">
              {SPORT_ID_ICON_MAP[sportId]}
            </div>
            <p className="timeline--text">{clock}&#39; - {currentEventTeamName}</p>
          </div>
          {!_.isEmpty(eventGoalPlayerName) && (<p className="timeline--text">득점 : {eventGoalPlayerName}</p>)}
        </>
      )
    }
    return null
  }

  /* --------- 농구 --------- */
  const renderBasketball = () => {
    if (isContentEmpty) {
      return null
    }

    if (timelineEventType === TimelineEventType.BREAK_START
      || timelineEventType === TimelineEventType.MATCH_ENDED) {
      return (
        <p className="timeline--text">
          {homeTeamName} {contentHomeScore}:{contentAwayScore} {awayTeamName}
        </p>
      )
    }

    return null
  }

  const renderSetBaseSports = () => {
    if (timelineEventType === TimelineEventType.BREAK_START
      || timelineEventType === TimelineEventType.MATCH_ENDED) {
      return (
        <p className="timeline--text">
          {homeTeamName} {contentHomeScore}:{contentAwayScore} {awayTeamName}
        </p>
      )
    }

    return null
  }

  /* --------- 분기 --------- */
  const content = (() => {
    switch (sportId) {
      case SPORTS_TYPE_NUM.SOCCER:
        return renderSoccer()
      case SPORTS_TYPE_NUM.BASEBALL:
        return renderBaseball()
      case SPORTS_TYPE_NUM.ICE_HOCKEY:
        return renderIceHockey()
      case SPORTS_TYPE_NUM.VOLLEYBALL:
      case SPORTS_TYPE_NUM.TABLE_TENNIS:
        return renderSetBaseSports()
      case SPORTS_TYPE_NUM.BASKETBALL:
        return renderBasketball()
      default:
        return null
    }
  })()

  return content ? <TimelineTextWrap>{content}</TimelineTextWrap> : null
}

export default AdvTimelineContent
